module.exports = __webpack_public_path__ + "ihd-logo-white.png?6efab1ea6e0ec6843096f59bbeaa8ae3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/ihd-logo-white.png
// module id = 68
// module chunks = 0